<script setup>
const year = new Date().getFullYear()
</script>

<template>
  <footer class="copyright body-text">&copy; {{ year }} The Global Career Accelerator</footer>
</template>

<style scoped>
.copyright {
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0;
  color: #6d6d6d;
}
</style>
